import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pss',
  templateUrl: './pss.component.html',
  styleUrls: ['./pss.component.scss']
})
export class PSSComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
